import React from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { MusicNote } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    background: "#9C27B0",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "white",
    position: "relative",
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.9,
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.9,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.75),
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 4,
    maxHeight: 80,
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #9C27B0",
    borderRadius: "50%",
  },
}));

const AudioNode = ({ data, selected }) => {
  const classes = useStyles();
  const caption = data?.caption || "";
  const hasMedia = !!data?.mediaUrl;

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        border: selected ? "2px solid rgba(255, 255, 255, 0.5)" : "1px solid rgba(255, 255, 255, 0.2)",
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        className={classes.handle}
        style={{ top: -6 }}
      />
      <Box className={classes.nodeHeader}>
        <MusicNote className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Audio</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {hasMedia ? (
          caption ? (
            caption.length > 50 ? `${caption.substring(0, 50)}...` : caption
          ) : (
            "Audio configurado"
          )
        ) : (
          "Sin audio"
        )}
      </Box>
      <Handle
        type="source"
        position={Position.Bottom}
        className={classes.handle}
        style={{ bottom: -6 }}
      />
    </Box>
  );
};

export default AudioNode;
